module.exports = __webpack_public_path__ + "img/custom-delete.ddf38287.svg";